module.exports = __webpack_public_path__ + "img/page2-bg.bbc7e0d8.png";